<template>
  <div class="document-container">
    <div class="columns is-desktop">
      <div class="column">
        <retire-merge-id/>
      </div>
      <div class="column is-3">
        <quick-tips-retire-merge-id/>
      </div>
    </div>
  </div>
</template>

<script>
import RetireMergeId from '@/components/ID Manager Components/RetireMergeId.vue';
import QuickTipsRetireMergeId from '@/components/ID Manager Components/QuickTipsRetireMergeId.vue';

export default {
  components: {
    RetireMergeId,
    QuickTipsRetireMergeId,
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
    padding: 0.5rem !important
</style>
